import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppComponent } from 'src/app/blocks/root/app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { EnumKeyValueListPipe } from '../pips/enumList.pipe';
import { ClassificationTypePipe } from '../pips/classificationType.pipe';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { PageNotFoundComponent } from '../components/page-not-found/page-not-found/page-not-found.component';
import { DatePerZonePipe } from '../pips/date.pipe';
import {
  MAT_DATE_LOCALE,
  MatNativeDateModule,
  MatOptionModule,
} from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';

import { MatDatepickerModule } from '@angular/material/datepicker';
import * as moment from 'moment';
import { FileUploaderComponent } from '../components/file-uploader/file-uploader.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
// import { AgmCoreModule } from '@agm/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {
  NgxMatDatetimePickerModule,
  NgxMatTimepickerModule,
  NgxMatNativeDateModule,
} from '@angular-material-components/datetime-picker';
import { ExportExcelComponent } from '../components/export-excel/export-excel.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDividerModule } from '@angular/material/divider';
import { TimezoneInterceptor } from 'src/app/core/common-services/time-zone-Interceptor';
import { WhitespaceValidatorDirective } from './jari-validators';
import { MatTabsModule } from '@angular/material/tabs';
import { TruncatePipe } from '../pips/truncate.pipe';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { InvestorCompanyDetailsComponent } from '../components/investor-company-details/investor-company-details.component';
import { NumberWithCommasDirective } from '../directives/number-with-commas.directive';
import { MaxRowsDirective } from '../directives/max-rows.directive';
import { NumberWithCommasPipe } from '../pips/number-with-commas.pipe';
import { PdfPreviewDialogComponent } from '../components/pdf-preview-dialog/pdf-preview-dialog.component';
import { WorkflowRequestAttachmentsComponent } from '../components/workflow-request-attachments/workflow-request-attachments.component';
@NgModule({
  declarations: [
    EnumKeyValueListPipe,
    ClassificationTypePipe,
    PageNotFoundComponent,
    DatePerZonePipe,
    FileUploaderComponent,
    ExportExcelComponent,
    WhitespaceValidatorDirective,
    TruncatePipe,
    InvestorCompanyDetailsComponent,
    NumberWithCommasDirective,
    NumberWithCommasPipe,
    PdfPreviewDialogComponent,
    WorkflowRequestAttachmentsComponent,
    MaxRowsDirective,


  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    // AgmCoreModule.forRoot({
    //   apiKey: 'AIzaSyDt-3iS_kTNAHFiFi32b2dSRU8NzlaWR8g',
    //   libraries: ['drawing', 'geometry'],
    // }),
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatMenuModule,
    MatTableModule,
    MatInputModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatOptionModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    AngularEditorModule,
    GoogleMapsModule,
    NgSelectModule,
    MatAutocompleteModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    MatSnackBarModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    DatePerZonePipe,
    TruncatePipe,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatMenuModule,
    MatTableModule,
    MatInputModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatCheckboxModule,
    EnumKeyValueListPipe,
    ClassificationTypePipe,
    MatExpansionModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatOptionModule,
    MatRadioModule,
    MatTooltipModule,
    FileUploaderComponent,
    MatDatepickerModule,
    MatNativeDateModule,
    AngularEditorModule,
    // AgmCoreModule,
    GoogleMapsModule,
    NgSelectModule,
    MatAutocompleteModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    MatBottomSheetModule,
    MatStepperModule,
    MatDividerModule,
    WhitespaceValidatorDirective,
    MatTabsModule,
    MatSnackBarModule,
    MatSidenavModule,
    InvestorCompanyDetailsComponent,
    NumberWithCommasDirective,
    NumberWithCommasPipe,
    PdfPreviewDialogComponent,
    WorkflowRequestAttachmentsComponent,
    MaxRowsDirective
    
  ],
  providers: [
    ExportExcelComponent,
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
  ],
})
export class SharedModule {}
